/**
 * お問い合わせ
 * 求人情報からお問い合わせページにきた時
 * メールフォームのお問い合わせ種類の初期値を変える
 */

export function contact() {
	window.onload = function () {

		const ref = document.referrer;
		//リンク元のパス
		const result = ref.match(/recruitment/)
		//表示しているページのパス
		const nowUrl = location.pathname;


		//表示しているページがお問い合わせページ
		if (nowUrl === "/contact") {
			//リンク元が求人情報の時
			if (result) {
				console.log('メール成功');
				const select = document.getElementById('kind');
				select.options[3].selected = true;
			}
		}

	}
}